// 各種カルーセルの設定
var swiperTopCover = new Swiper ('.swiper-top-cover', {
    // init: false,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1200,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    autoplay: {
      delay: 5000
    },
    on: {
      init: changeSlideName
    }
});

var swiperAboutStaff = new Swiper ('.swiper-about-staff', {
    loop: true,
    slidesPerView: 1.3,
    spaceBetween: 16,
    centeredSlides: true,
    speed: 300,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: '.staff-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.staff-button-next',
      prevEl: '.staff-button-prev',
    },
});


// Swiper カスタム
function changeSlideName( target ){

  var target = this;

  if( ! target  ) return false;
  var duplicateNum = 2;

  var currentInfo,
      targetTitleLink,
      changeTimer,
      slideIndex,
      currentIndex;

  // 初期処理
  var currentSlide  = target.slides[1];
  var slideDataName = currentSlide.getAttribute('data-name');
  var slideWrapper  = target.$el[0];
  var slideCaption  = $('#slide-caption');
  var captionText   = slideCaption.find('.caption-text');

  var captionNum    = slideCaption.find('.caption-number');
  var numberCurrent = captionNum.find('p span.num-current');
  var numberAll     = captionNum.find('p span.num-all');

  currentInfo = [ slideDataName ];
  captionText.find('p').text( currentInfo[0] );

  numberCurrent.text( currentIndex );
  numberAll.text( target.slides.length - duplicateNum );


  // スライド時の処理
  target.on('slideChangeTransitionStart', function(){

    clearTimeout( changeTimer );

    slideIndex    = target.realIndex;
    currentIndex  = slideIndex + 1;

    currentSlide  = target.slides[currentIndex];
    slideDataName = currentSlide.getAttribute('data-name');
    slideWrapper  = target.$el[0];
    slideCaption  = $('#slide-caption');
    captionText   = slideCaption.find('.caption-text');

    captionNum    = slideCaption.find('.caption-number');
    numberCurrent = captionNum.find('p span.num-current');
    numberAll     = captionNum.find('p span.num-all');

    captionText.find('p').addClass('hide');
    captionNum.find('p').addClass('hide');

    currentInfo = [ slideDataName ];

    changeTimer = setTimeout( function(){

      captionText.find('p').text( currentInfo[0] );
      captionText.find('p').removeClass('hide');

      numberCurrent.text( currentIndex );
      captionNum.find('p').removeClass('hide');

    }, 600 );

  });

}

function faqToggle(){

  var toggleFaq = $('#toggle-faq');
  if( toggleFaq.length === 0 ) return false;

  toggleFaq.find('.item').each( function(){

    $(this).find('.item-title').on({

      'click' : function(){

        if( $(this).parent().hasClass('hide') ){

          $(this).parent().removeClass('hide');

        } else {

          $(this).parent().addClass('hide');

        }

      }

    });

  } );

}


// ハンバーガーメニュー
function drawerControl() {

  var objectBody   = $('body');
  var menuButton   = $('#menuButton');
  var drawerMenu   = $('#drawerGlobalMenu');

  if( menuButton.length === 0 ) return false;

  var closeTimer;

  menuButton.on({

    'click' : function(){

      if( objectBody.hasClass('drawer-open') ){

        objectBody.removeClass('drawer-open');

      } else {

        objectBody.addClass('drawer-open');

      }

      return false;
    }

  });

  drawerMenu.find('.menu-main ul li').each(function(){
    $(this).find('a').on({
      'click' : function(){

        if( objectBody.hasClass('drawer-open') ){

          closeTimer = setTimeout(function(){

            objectBody.removeClass('drawer-open');

          }, 600);
        }
      }
    });
  });

}

// スムーススクロール
function smoothScroll(){

  // aタグ要素の参照を取得
  const links = document.querySelectorAll('a[href^="#"]');

  // 各aタグにクリックイベントを設定
  for ( let i = 0; i < links.length; i++ ) {
    links[i].addEventListener('click', function(e){

      // デフォルトのイベントをキャンセル
      e.preventDefault();

      var target        = e.target;
      // var targetId      = target.hash;

      if( target.tagName != 'A' ){

        // console.log( target.tagName );
        var targetId = target.parentNode.hash;

      } else {

        console.log( target.tagName );
        var targetId = target.hash;

      }

      if( targetId === '' || targetId === undefined ) return false;

      var targetElement = document.querySelector(targetId);
      var rectTop       = targetElement.getBoundingClientRect().top;

      //ヘッダーの高さを計算
      // const headerBar  = document.getElementById('site-header');
      // const headerBarHeight = headerBar.offsetHeight;
      // var buffer = headerBarHeight;

      var offsetTop = window.pageYOffset;
      var buffer = 0;
      var top = rectTop + offsetTop - buffer;

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
}

function showContactButton(){
  var floatingContactButton = $('#floatingContactButton');
  if( floatingContactButton.length === 0 ) return false;

  setTimeout( function(){

    floatingContactButton.addClass('show');

  }, 3000 );


}

function showInstagramFeeds(){

  var setting = {
    hashtag_id : '',
    instagram_business_id : '17841432366238621',
    access_token : 'EAAGEQyMG9soBANqfqSdsmT8jtEl8QpmaXZCMHJZBgZCeZCXxvl5MixK8v3NZARdIvN7iS4HLYQ3QWBPrpMJWonbfJxQ3ZCILoSFZAEnKifZBjOfdVwzHjgeEeOpZBcYWSINUiB7h6W6eJsR3sctQ4OsmJKmkayHMXaZAMsiL7ZBZAAUhWne0aukd5g2n11k9Q1ItWbEZD',
    limit : 9
  };

  //json URL生成
  var jsonUrl = 'https://graph.facebook.com/v8.0/' + setting.instagram_business_id + '?fields=name%2Cmedia.limit(' + setting.limit + ')%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cusername%2Cmedia_type%2Cthumbnail_url%7D&access_token=' + setting.access_token ;
  var feedArray = [];

  $.ajax({
  	type: 'GET',
  	url: jsonUrl,
  	dataType: 'json',
  	success: function(json) {

      var feeds   = json.media.data;

      for (var i = 0; i < feeds.length; i++) {

        var feed_permalink     = feeds[i].permalink;
        var feed_media_url     = feeds[i].media_url;
        var feed_media_type    = feeds[i].media_type;
        var feed_thumbnail_url = feeds[i].thumbnail_url;
        var img_url            = feed_media_type != 'VIDEO' ? feed_media_url : feed_thumbnail_url;

        articles = '<article class="item feed"><a href="' + feed_permalink + '" target="_blank"><img data-src="' + img_url + '" class="lazyload" /></a></article>';
        feedArray.push( articles );
      }
      $.each( feedArray, function(i, val){
        $("#ig-feed").append( val );
      });

      lazyload();

  	}
  });


}


jQuery(function($){

  //
  $( "#switch-map" ).tabs();

  // フォーム関連の処理
  if( $("input[type=date]").length ){
    $("input[type=date]").flatpickr({
      locale: 'ja',
      minDate: new Date().fp_incr(2),
      altInput: true,
      altFormat: "Y年m月d日",
      dateFormat: "Y-m-d"
    });
  }
  $('select.wpcf7-select').selectBoxIt();

  // 各種ファンクションの実行
  faqToggle();
  drawerControl();
  smoothScroll();
  showContactButton();
  showInstagramFeeds();

});
